import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SendIcon from '@material-ui/icons/Send';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import FilterListIcon from '@material-ui/icons/FilterList';
import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState } from 'react';
import trLocale from 'date-fns/locale/tr';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import { sc, moneyFormat } from 'src/utils/Common';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import {
  Card,
  Avatar,
  Input,
  DialogContent,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  IconButton,
  TextField,
  ThemeProvider,
  MenuItem,
  createMuiTheme,
  CardHeader,
  Box,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar,
  TablePagination, ListItemAvatar, ListItem, ListItemText, List
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';

import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Page from 'src/components/Page';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import moment from 'moment';
import axios from 'src/utils/axios';

import { getUser } from 'src/utils/Common';
import { func } from 'prop-types';
import { retry } from '@redux-saga/core/effects';
import Alert from 'src/components/Alert';
import UrunSearch from '../../components/Selects/ProductSearch';
import ProductMaterialSearch from 'src/components/Selects/ProductMaterialSearch'
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import RetailerSearch from 'src/components/Selects/RetailerSearch';

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));

const MaterialOrder = props => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [SelectedMaterialPopup, setSelectedMaterialPopup] = useState(false);
  const [UrunData, setUrunData] = useState({});
  const [search] = useState('');
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const SessionUser = getUser();
  const [stokOpen, setStokOpen] = React.useState(false);
  const [stokData, setStokData] = React.useState([]);
  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblReject') },
    { Id: 4, Name: t('lblSubmittedforApproval') },
    { Id: 5, Name: t('lblSAPSent') }
  ]);
  const [selectedStatus, setSelectedStatus] = useState({ Id: 1, Name: 'New' });
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [SearchOrderParam, setSearchOrderParam] = React.useState('');
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [SparepartData, setSparePartData] = useState([]);
  const [QueryPopUp, setQueryPopUp] = useState(false);
  const [ServiceShopData, SetServiceShopData] = useState([]);
  const [serviceShopId, setServiceShopId] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [scroll, setScroll] = React.useState('paper');
  //const [ExportPopup, setExportPopup] = React.useState(false);
  const [initialRows, setinitialRows] = useState('');
  const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
  const [ErpStatusData, setErpStatusData] = React.useState([]);

  const exportMaterialData = (data) => {
    var json = []
    for (let i = 0; i < data?.length; i++) {
      var temp = {};
      temp.ProductId = data[i].ProductId;
      temp.lblProductName = data[i].ProductName;
      temp.MaterialCode = data[i].MaterialCode;
      temp.MaterialDesc = data[i].MaterialDesc;
      temp.Ref = data[i].Ref;
      temp.lblQuantity = data[i].Quantity;
      temp.UseQuantity = data[i].UseQuantity;
      temp.Price = data[i].Price;
      temp.PriceWithWat = data[i].PriceWithWat;
      temp.lblTotal = data[i].Total;
      json.push(temp)
    };

    return json
  };
  const getStokColor = s => {
    if (s.Quantity !== "0,0") {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };
  const defaultMaterialOrder = {
    service: SessionUser.ServiceShopName,
    orderNumber: 0,
    orderDate: moment().format('YYYY-MM-DD'),
    sapNumber: '',
    jobNumber: '',
    modelCode: '',
    status: statusList[0].Name,
    recipientName: '',
    description: '',
    recipientAddress: '',
    ServiceShopId:
      SessionUser.Role === 1 || SessionUser.Role === 2 || SessionUser.Role === 5
        ? SessionUser.ServiceShopId
        : 0
  };

  const DefaultWorkCase = {
    ConsumerId: 0,
    ProductId: 0,
    ProductionYear: 0,
    ProductionMonth: 0,
    SerialNr: '0',
    Product: '',
    OnSiteOperation: 0,
    WarrantyTypeId: 0,
    IssueId: 1,
    Issue: '',
    RetailerId: 0,
    Retailer: '',
    StatusId: 1,
    Comment: '',
    WarrantyDate: '01.01.2021',
    AppointmentDate: moment()
      .startOf('day')
      .add(1, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD hh:mm'),
    AppointmentEndDate: moment()
      .startOf('day')
      .add(1, 'days')
      .add(13, 'hours')
      .format('YYYY-MM-DD hh:mm')
  };



  const [MaterialOrderData, setMaterialOrderData] = useState(
    defaultMaterialOrder
  );
  const [MaterialListData, setMaterialListData] = useState([]); 

  const [retailerData, setRetailerData] = useState([]);
  const [selectedRetailer, setSelectedRetailer] = useState(0);
  const [address, setAddress] = useState('');


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [QuerySearchData, setQuerySearchData] = useState([]);
  const [QuerySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');
  const [currentStatus, setCurrentStatus] = useState(0);
  const [searched, setSearched] = useState('');
  const [DisabledControl, setDisabledControl] = useState(false);
  const [NewWorkCaseData, setNewWorkCaseData] = useState(DefaultWorkCase);
  const [inputText, setInputText] = useState("");
  const [materialAvailabilityCode,setMaterialAvailabilityCode] = React.useState([]);




  useEffect(() => {
    if (props?.MaterialOrderIdPopup > 0) {
      setSearchOrderParam(props?.MaterialOrderIdPopup);
      GetMaterialOrderParamNew(props?.MaterialOrderIdPopup);
    }
  }, [props?.MaterialOrderIdPopup]);



  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2 || parseInt(SessionUser.Role) === 5) {

      setDisabledControl(true);
      setServiceShopId({ ServiceShopId: SessionUser.ServiceShopId });
    }
  }, [SessionUser.Role]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const GetMaterialOrderRequest = () => {
    if (!serviceShopId?.ServiceShopId) {
      return
    }
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: selectedStatus.Id,
      StartDate,
      EndDate,
      ServiceShopId: serviceShopId.ServiceShopId,
      OrderNr: MaterialOrderData.orderNumber | 0
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetServiceShopRequest = () => {
    axios
      .get('/GetServiceShopRequest/')
      .then(response => {
        if (response.data.length > 0) {
          SetServiceShopData(response.data);
          setServiceShopId(
            response.data[
            response.data.findIndex(
              x => x.ServiceShopId == SessionUser.ServiceShopId
            )
            ]
          );
        }
      })
      .catch(error => { });
  };

  const GetRetailer = () => {
    var code = ServiceShopData.find(x => x.ServiceShopId == SessionUser.ServiceShopId)?.ShipTo;
    axios
      .get('/GetRetailer/0/' + code) 
      .then(response => {
        if (response.data.length > 0) {
          setRetailerData(response.data);
        }
      })
      .catch(error => { });
  };
  

  const handleRetailerChange = (event, newValue) => {
    setSelectedRetailer(newValue);
    if (newValue) {
      setAddress(newValue.Address);
    } else {
      setAddress('');
    }
  };

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };

  useEffect(() => {
    GetServiceShopRequest();
  }, [locale]);
  
  useEffect(() => {
    GetRetailer();
  }, [ServiceShopData]);

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';
  const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  const ValidateFields = () => {
    const descIsNull = !!(
      MaterialOrderData.description == '' ||
      MaterialOrderData.description == undefined
    );
    const recipientNameIsNull = !!(
      MaterialOrderData.recipientName == '' ||
      MaterialOrderData.recipientName == undefined
    );
    const recipientAddressIsNull = !!(
      MaterialOrderData.recipientAddress == '' ||
      MaterialOrderData.recipientAddress == undefined
    );
    const sparePartListIsEmpty = SparepartData.length === 0;

    if (
      descIsNull ||
      //recipientNameIsNull ||
      //recipientAddressIsNull ||
      sparePartListIsEmpty
    ) {
      return false;
    }

    return true;
  };

  function saveWorkOrder(StatusId) {
    if (ValidateFields()) {
      setLoading(true);
      const SetMaterialOrderDetailRequestDto = [];
      for (let i = 0; i < SparepartData.length; i++) {
        const tmpSparePartData = {
          Id: MaterialOrderData.orderNumber,
          RowId: i + 1,
          MaterialId: SparepartData[i].MaterialId,
          Qty: SparepartData[i].Quantity,
          ProductId: SparepartData[i].ProductId,
          CreateEmployeeId: SessionUser.TechnicianId,
          CreateDate: moment()
        };

        SetMaterialOrderDetailRequestDto.push(tmpSparePartData);
      }

      const setMaterialRequestDto = {
        Id: MaterialOrderData.orderNumber,
        ServiceShopId: MaterialOrderData.ServiceShopId,
        OrderDate: MaterialOrderData.orderDate,
        StatusId,
        WorkOrderId: MaterialOrderData.jobNumber || 0,
        Dsc: MaterialOrderData.description,
        RecipientDsc: MaterialOrderData.recipientName,
        RecipientAddress: MaterialOrderData.recipientAddress,
        AcceptDate: MaterialOrderData.orderDate,
        SapNr: MaterialOrderData.SapNr,
        CreateEmployeeId: SessionUser.TechnicianId,
        CreateDate: moment(),
        MaterialOrderDetails: SetMaterialOrderDetailRequestDto
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetMaterialOrder', setMaterialRequestDto, config)
        .then(response => {
          if (response.data.IsSuccess) {
            const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            setMaterialOrderData({
              ...MaterialOrderData,
              orderNumber: response?.data?.OrderNr,
              sapNumber: response?.data?.SapNr,
              status: tmpStatus
            });
            setCurrentStatus(StatusId);
            setResponseType('success');
            setResponseDsc(t('success_message'));
            setOpenSnackbar(true);
          } else {
            setResponseType('error');
            setResponseDsc(response.data.ErrorMessage || t('lblMustRole'));
            setOpenSnackbar(true);
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    } else {
      handleSnackbarClick();
    }
  }

  function addToMaterialTable(row) {
    const tmpRow = row;
    const tmpList = [...SparepartData];
    const ifAlreadyHaveItem = tmpList.find(
      x => x.MaterialId === tmpRow.MaterialId
    );
    if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
      tmpRow.Quantity = 1;
      tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
      tmpList.push(tmpRow);
    } else {
      const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
      tmpList[index].Quantity += 1;
      tmpList[index].Total =
        tmpList[index].Quantity * tmpList[index].PriceWithWat;
    }
    setSparePartData(tmpList);
  }

  const deleteFromMaterialTable = row => {
    const tmpListData = [...SparepartData];
    const index = tmpListData.findIndex(x => x.MaterialId === row.MaterialId);
    tmpListData.splice(index, 1);
    setSparePartData(tmpListData);
  };

  const decrementFromMaterialTable = row => {
    const tmpRow = row;
    const tmpList = [...SparepartData];
    const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
    if (tmpList[index].Quantity === 1) {
      // deleteFromMaterialTable(row)
    } else {
      tmpList[index].Quantity -= 1;
      tmpList[index].Total =
        tmpList[index].Quantity * tmpList[index].PriceWithWat;
      setSparePartData(tmpList);
    }
  };

  const clearPage = () => {
    setMaterialOrderData(defaultMaterialOrder);
    setMaterialListData([]);
    setSparePartData([]);
  };

  const SetDate = value => {
    const DateValue = moment(value).format('YYYY-MM-DD');
    setMaterialOrderData({ ...MaterialOrderData, orderDate: DateValue });
  };

  const setModel = param => {

    setMaterialListData([]);
    const job = {
      ModelCode: param.KUL_MODEL_KODU,
      Model: param.ACIKLAMA,
      HomeWhiz: param.HOMEWHIZ,
      BrandCode: param.MARKA_KODU,
      ProductId: param.MODEL_KODU
    };

    setUrunData(job);

    setLoading(true);
    axios
      .get(`/GetSiriusMaterials/${param.KUL_MODEL_KODU}/1/1/1/1/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/-2`)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          response.data.forEach(element => {
            element.ProductId = param.MODEL_KODU
            element.ProductName = param.ACIKLAMA
          });
          setMaterialListData(response.data);
          setinitialRows(response.data);
        } else {
          setMaterialListData([]);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const malzemeGosterMaterial = materialCode => {
    const data = {
      MaterialCode: materialCode
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusMaterialImage', data, config)
      .then(response => {
        const fileURL = URL.createObjectURL(response.data);

        // newWindow.location = fileURL;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURL);
        setImagePopup(true);
      })
      .catch(error => { });
  };

  const updateWorkOrder = statusId => {
    saveWorkOrder(statusId);
  };

  const changeSelectedStatus = status => {
    setSelectedStatus(status);
  };
  const handleSnackbarClick = () => {
    setResponseType('error');
    setResponseDsc(t('lblMissingFields'));
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const setQuery = row => {

    const defaultMaterialOrderParam = {
      ServiceShopId: row.ServiceShopId,
      service: `${row.SourceServiceShopCode} ${row.ServiceShop}`,
      orderNumber: row.MaterialOrderId,
      orderDate: row.OrderDate,
      sapNumber: row.SapNr ? row.SapNr : '',
      jobNumber: row.WorkOrderId ? row.WorkOrderId : '',
      modelCode: '',
      status: row.MaterialOrderStatus,
      recipientName: row.RecipientDsc,
      description: row.Dsc,
      recipientAddress: row.RecipientAddress
    };

    const DetailData = [];
    row.MaterialOrderDetails.forEach(item => {
      const Data = {};
      Data.MaterialId = item.MaterialId;
      Data.MaterialCode = item.MaterialCode;
      Data.MaterialDesc = item.Material;
      Data.Quantity = item.Qty;
      Data.UseQuantity = item.OriginalQty;
      Data.Price = item.Price;
      Data.PriceWithWat = item.PriceWithWat;
      Data.Total = item.PriceWithWat * item.Qty;
      Data.ProductId = item.ProductId
      Data.ProductName = item.ProductName
      DetailData.push(Data);
    });

    setCurrentStatus(row.StatusId);
    setMaterialOrderData(defaultMaterialOrderParam);
    setSparePartData(DetailData);
    setQueryPopUp(false);
    setQuerySearchScreenData([]);
  };


  const requestSearch = (searchedVal) => { 
    const filteredRows = initialRows.filter((item) => sc(
      item.MaterialCode + item.MaterialDesc + item.PriceWithWat.toFixed(2),
      searchedVal
    ));
    setMaterialListData(filteredRows);
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const StokControlPopup = (row) => {
    const Request = {
      MaterialCode: [row.MaterialCode],
      ServiceShopCode: SessionUser.ServiceShopCode
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setStokData(res);
        setMaterialAvailabilityCode(row.MaterialCode);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setStokOpen(true);
  }

  const exportData = (data) => {
    var json = []

    data.map(row => (
      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => {
        var temp = {};
        temp.lblWorkOrderId = row.WorkOrderId;
        temp.lblServiceShop = `${row.SourceServiceShopCode} ${row.ServiceShop}`;
        temp.lblMaterialOrderId = row.MaterialOrderId;
        temp.lblRecipientDsc = row.RecipientDsc;
        temp.lblRecipientAddress = row.RecipientAddress;
        temp.lblMaterialCode = det.MaterialCode;
        temp.lblMaterial = det.Material;
        temp.lblQuantity = det.Qty;
        temp.lblModelCode = det.ModelCode;
        temp.lblProductName = det.ProductName;
        temp.lblSapNr = row.SapNr;
        temp.lblOrderDate = row.OrderDate === undefined ? '' : moment(row.OrderDate).format('DD/MM/YYYY HH:mm');
        temp.lblMaterialOrderStatus = row.MaterialOrderStatus;
        temp.lblDescription = row.Dsc;
        temp.lblTotalPrice = moneyFormat(
          det.PriceWithWat,
          SessionUser.TenantCode,
          SessionUser.CurrencyUnit
        ) + `${SessionUser.CurrencyUnit}`;
        json.push(temp)
      }
      ) : null))

    return json
  }

  const GetMaterialOrderParamNew = (OrderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: OrderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);



      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetMaterialOrderParam = () => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: SearchOrderParam
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);



      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const setRetailer = param => {
    if (param.Dsc && param.Id) {
      var Data = { ...NewWorkCaseData };
      Data.Retailer = param.Dsc;
      Data.RetailerId = param.Id;
      setNewWorkCaseData(Data);
      setMaterialOrderData({
        ...MaterialOrderData,
        recipientName: param.Dsc,
        recipientAddress: param.Address
      })
    }
    else {
      var Data = { ...NewWorkCaseData };
      Data.Retailer = param;
      Data.RetailerId = 0;
      setNewWorkCaseData(Data);
      setMaterialOrderData({
        ...MaterialOrderData,
        recipientName: param
      })
    }

  };

  function setProductMaterial(materialData) {
    if (UrunData.Model && UrunData.ModelCode) {
      if (UrunData.ProductId >= 1000000) {
        setMaterialListData([]);
        materialData.ProductId = UrunData.ProductId
        materialData.ProductName = UrunData.Model
        let result = []
        result.push(materialData)
        setMaterialListData(result);
        setinitialRows(result);
      }
    }
    else {
      setResponseType('error');
      setResponseDsc(t('lblChooseProduct'));
      setOpenSnackbar(true)
    }
  }

  const ErpStatusPopup = (ErpNr) => {
    axios
      .get('/GetErpWarehouseMaterialStatus/' + ErpNr + '/' + localStorage.getItem('i18nextLng'))
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setErpStatusOpen(true);
  }

  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Container maxWidth="xl">
        <Breadcrumbs>
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('Material_Order')}</Typography>
        </Breadcrumbs>
        <Card>
          <BottomNavigation
            value={TopBarValue}
            className={classes.stickToBottom}
            onChange={(event, newValue) => {
              setTopBarValue(newValue);
              if (newValue === 0) {

                saveWorkOrder(1);
                // KAYDET
              }
              if (newValue === 1) {
                // NEW ORDER
                clearPage();
                setCurrentStatus(0);
              }
              if (newValue === 2) {
                // İPTAL
                updateWorkOrder(newValue);
              }
              if (newValue === 3) {
                // REJECT
                updateWorkOrder(newValue);
              }
              if (newValue === 4) {
                // ONAYA GÖNDER
                updateWorkOrder(newValue);
              }
              if (newValue === 5) {
                // SAP GÖNDER
                updateWorkOrder(newValue);
              }
              if (newValue === 6) {
                // QUERY
                setQueryPopUp(true);
              }
            }}
            showLabels
          >
            {currentStatus === 5 ? (
              ''
            ) : (
              <BottomNavigationAction
                label={t('lblSave')}
                icon={<SaveIcon />}
              />
            )}
            <BottomNavigationAction
              label={t('lblNewOrder')}
              icon={<AddShoppingCartIcon />}
            />
            {(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 3 || currentStatus === 4) ? (
              <BottomNavigationAction
                label={t('lblCancel')}
                icon={<CancelIcon />}
              />
            ) : (
              ''
            )}
            {!(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 4) ? (
              <BottomNavigationAction
                label={t('lblReject')}
                icon={<CancelIcon />}
              />
            ) : (
              ''
            )}
            {(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 3) ? (
              <BottomNavigationAction
                style={{ display: 'none' }}
                label={t('lblSubmittedforApproval')}
                icon={<ThumbUpAltIcon />}
              />
            ) : (
              ''
            )}
            {!(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              currentStatus === 4 || currentStatus === 1 || currentStatus === 4 ? (
              <BottomNavigationAction
                label={t('lblSendToSap')}
                icon={<SendIcon />}
              />
            ) : (
              ''
            )}
            {currentStatus === 5 ? (
              <BottomNavigationAction
                label={t('lblQuery')}
                icon={<FilterListIcon />}
              />
            ) : (
              <BottomNavigationAction
                label={t('lblQuery')}
                icon={<FilterListIcon />}
              />
            )}
          </BottomNavigation>
        </Card>
        <Divider />
        <Card>
          <CardHeader title={t('lblMaterialOrderInformation')}
            action={
              <Paper className={classes.searchB} elevation={1}>
                <Input
                  className={classes.searchInputB}
                  disableUnderline
                  // onKeyDown={handleKeyDown}
                  onChange={(event) => {
                    setSearchOrderParam(event.target.value);
                  }}
                  placeholder={t('lblOrderNumber')}
                />
                <SearchIcon
                  onClick={() => GetMaterialOrderParam()}
                  className={classes.searchIconB}
                />
              </Paper>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>

              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          disabled
                          size="small"
                          id="service"
                          autoComplete="no"
                          value={MaterialOrderData.service}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              service: event.target.value
                            })}
                          fullWidth
                          label={t('lblServiceShop')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="status"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.status}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              status: event.target.value
                            })}
                          fullWidth
                          label={t('lblStatus')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="orderNumber"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.orderNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              orderNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblOrderNumber')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <ThemeProvider theme={materialTheme}>
                          <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                          >
                            <KeyboardDatePicker
                              color="primary"
                              inputVariant="outlined"
                              id="orderDate"
                              disabled
                              size="small"
                              invalidDateMessage={t('hatali_tarih')}
                              format="dd.MM.yyyy"
                              fullWidth
                              autoComplete="off"
                              label={t('lblOrderDate')}
                              variant="outlined"
                              value={MaterialOrderData.orderDate}
                              onChange={e => SetDate(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change date'
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Grid>
                      <Grid item xs={11} sm={11} lg={11}>
                        <TextField
                          size="small"
                          id="sapNumber"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.sapNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              sapNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblSapNumber')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={1} sm={1} lg={1}>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <ControlCameraIcon
                                size="small"
                                color="primary"
                                style={{ color: '#3399FF' }}
                                onClick={() => ErpStatusPopup(MaterialOrderData.sapNumber)}
                              />
                            </Box>
                          }

                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="jobNumber"
                          autoComplete="no"
                          type="number"
                          value={MaterialOrderData.jobNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              jobNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblWorkOrderId')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="description"
                          multiline
                          rows={10}
                          autoComplete="no"
                          value={MaterialOrderData.description}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              description: event.target.value
                            })}
                          fullWidth
                          label={t('lblDescription')}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        {/* <TextField
                          size="small"
                          id="recipientName"
                          autoComplete="no"
                          value={MaterialOrderData.recipientName}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              recipientName: event.target.value
                            })}
                          fullWidth
                          label={t('lblRecipientName')}
                          variant="outlined"
                        /> */}
                        {/* <RetailerSearch
                          setRetailer={setRetailer}
                          label={"lblRetailerShipTo"}
                          value={
                            {
                              Dsc: NewWorkCaseData.Retailer || '',
                              Id: NewWorkCaseData.RetailerId || 0
                            } || ''
                          }
                          searchParam={search}
                        /> */}
                         <Autocomplete
                          size="small"
                          fullWidth
                          autoSelect
                          disableClearable
                          options={retailerData || []}
                          getOptionLabel={option => (option ? option.Dsc : '')}
                          value={selectedRetailer || null}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblRetailer')}
                              variant="outlined"
                            />
                          )}
                          onChange={handleRetailerChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="recipientAddress"
                          autoComplete="no"
                          multiline
                          rows={10}
                          value={address}
                          onChange={handleAddressChange}
                          fullWidth
                          label={t('lblRetailerShipToAddress')}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <BottomNavigation>
            {/* <ExcelExport JsonData={exportMaterialData(SparepartData)}  ButtonType={1}/> */}
            <BottomNavigationAction
              onClick={() => setSelectedMaterialPopup(true)}
              showLabel
              label={t('Add Material')}
              icon={<AddBoxIcon />}
            />
          </BottomNavigation>
          <Divider />
          <CardContent>
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell />
                    <TableCell align="left">{t('lblProductName')}</TableCell>
                    <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                    <TableCell align="left">{t('lblMaterial')}</TableCell>
                    <TableCell align="right">{t('lblQuantity')}</TableCell>
                    <TableCell align="right">
                      {t('lblOriginalQuantity')}
                    </TableCell>
                    <TableCell align="right">{t('lblPrice')}</TableCell>
                    <TableCell align="right">{t('lblPriceWithVat')}</TableCell>
                    <TableCell align="right">{t('lblTotal')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SparepartData.map(row => (
                    <TableRow key={row.MaterialId}>
                      <TableCell align="center">
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <DeleteIcon
                                size="small"
                                color="primary"
                                style={{ color: 'red' }}
                                onClick={() => deleteFromMaterialTable(row)}
                              />
                            </Box>
                          }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <LocalGroceryStoreIcon
                                size="small"
                                color="primary"
                                style={{ color: '#3399FF' }}
                                onClick={() => StokControlPopup(row)}
                              />
                            </Box>
                          }

                        />
                      </TableCell>
                      <TableCell align="left">{row.ProductName}</TableCell>
                      <TableCell align="left" component="th" scope="row">
                        {row.MaterialCode}
                      </TableCell>
                      <TableCell align="left">{row.MaterialDesc}</TableCell>
                      <TableCell align="right">
                        <ArrowDropUpIcon
                          size="small"
                          color="primary"
                          style={{ color: 'red' }}
                          onClick={() => addToMaterialTable(row)}
                        >
                        </ArrowDropUpIcon>
                        {row.Quantity}
                        <ArrowDropDownIcon
                          size="small"
                          color="primary"
                          style={{ color: 'red' }}
                          onClick={() => decrementFromMaterialTable(row)}
                        >
                        </ArrowDropDownIcon>
                      </TableCell>
                      <TableCell align="right">{row.UseQuantity}</TableCell>
                      <TableCell align="right">
                        {moneyFormat(
                          row.Price,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        )}
                        {`${SessionUser.CurrencyUnit}`}
                      </TableCell>
                      <TableCell align="right">
                        {moneyFormat(
                          row.PriceWithWat,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        )}
                        {`${SessionUser.CurrencyUnit
                          }`}
                      </TableCell>
                      <TableCell align="right">
                        {moneyFormat(
                          row.Total,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        )}
                        {`${SessionUser.CurrencyUnit}`}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="right">
                      <b>{t('lblTotal')}</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>
                        {` ${SparepartData.reduce(
                          (n, { Quantity }) => n + Quantity,
                          0
                        )} `}
                      </b>
                    </TableCell>
                    <TableCell align="center" />
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { Price }) => n + Price,
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { PriceWithWat }) => n + PriceWithWat,
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { Total }) => n + Total,
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      {/* Add Material From Product BOM */}
      <Dialog
        open={SelectedMaterialPopup}
        fullWidth
        maxWidth="lg"
        onClose={() => setSelectedMaterialPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('Add Material From Product BOM')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <UrunSearch
                    setModel={setModel}
                    value={
                      {
                        KUL_MODEL_KODU: UrunData.ModelCode,
                        ACIKLAMA: UrunData.Model
                      } || ''
                    }
                    searchParam={search}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <ProductMaterialSearch
                    setProductMaterial={setProductMaterial}
                    materialIsVisible={(UrunData.Model && UrunData.ModelCode && UrunData.ProductId >= 1000000) ? true : false}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={4} sm={4} lg={4}>
                  <SearchBar
                    // inputSizeSmall
                    value={searched}
                    onChange={searchVal => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      size="small"
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell />
                          <TableCell align="left">
                            {t('lblMaterialCode')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDescription')}
                          </TableCell>
                          <TableCell align="right">{t('lblPrice')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? MaterialListData.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : MaterialListData
                        ).map(row => (
                          <TableRow key={row.MaterialId}>
                            <TableCell
                              align="center"
                              className={classes.tableCellMaterial}
                            >
                              <FormControlLabel
                                control={
                                  <ImageSearchIcon
                                    onClick={() =>
                                      malzemeGosterMaterial(row.MaterialCode)
                                    }
                                    color="primary"
                                  >
                                  </ImageSearchIcon>
                                }
                              />
                            </TableCell>
                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <AddBoxIcon
                                    color="primary"
                                    onClick={() => addToMaterialTable(row)}
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              {row.MaterialCode}
                            </TableCell>
                            <TableCell align="left">
                              {row.MaterialDesc}
                            </TableCell>
                            <TableCell align="right">
                              {`${row.PriceWithWat.toFixed(2)} ${SessionUser.CurrencyUnit
                                }`}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={MaterialListData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => setSelectedMaterialPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={QueryPopUp}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => setQueryPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblQuery')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3} lg={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    options={ServiceShopData}
                    getOptionLabel={option => (option ? option.Dsc : '')}
                    value={serviceShopId}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label={t('lblServiceShop')}
                        variant="outlined"
                      />
                    )}
                    onChange={(event, value) => {
                      setServiceShopId(value);
                    }}
                    disabled={DisabledControl}
                  />
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('lblStatus')}
                    id="StatusId"
                    variant="outlined"
                    value={selectedStatus.Id}
                  >
                    {statusList?.map(h => {
                      return (
                        <MenuItem
                          onClick={() => changeSelectedStatus(h)}
                          key={h.Id}
                          value={h.Id}
                        >
                          {h.Name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="primary"
                        inputVariant="outlined"
                        id="orderDate"
                        size="small"
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        label={t('BaslangicTarihi')}
                        variant="outlined"
                        value={StartDateSearch}
                        onChange={e => handleChangeStartDateSearch(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="primary"
                        inputVariant="outlined"
                        id="orderDate"
                        size="small"
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        autoComplete="off"
                        label={t('BitisTarihi')}
                        variant="outlined"
                        value={EndDateSearch}
                        onChange={e => handleChangeEndDateSearch(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <TextField
                    size="small"
                    id="orderNumber"
                    autoComplete="no"
                    value={MaterialOrderData.orderNumber}
                    onChange={event =>
                      setMaterialOrderData({
                        ...MaterialOrderData,
                        orderNumber: event.target.value
                      })}
                    fullWidth
                    label={t('lblOrderNumber')}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={2} lg={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    endIcon={<SearchIcon />}
                    onClick={GetMaterialOrderRequest}
                  >
                    {t('search')}
                  </Button>
                </Grid>
                {/* <Grid item xs={12} sm={2} lg={1}>
                  <ExcelExport JsonData={exportData(QuerySearchScreenData)} />
                </Grid> */}

              </Grid>
            </CardContent>
            <CardContent className={classes.cardscontent}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t('lblJobNumber')}</TableCell>
                      <TableCell align="left">{t('lblServiceShop')}</TableCell>
                      <TableCell align="left">{t('lblOrderNumber')}</TableCell>
                      <TableCell align="left">{t('lblRecipientName')}</TableCell>
                      <TableCell align="left">{t('lblRecipientAddress')}</TableCell>
                      <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                      <TableCell align="left">{t('lblMaterial')}</TableCell>
                      <TableCell align="left">{t('lblQuantity')}</TableCell>
                      <TableCell align="left">{t('lblOrderDate')}</TableCell>
                      <TableCell align="left">{t('lblModelCode')}</TableCell>
                      <TableCell align="left">{t('lblProductName')}</TableCell>
                      <TableCell align="left">{t('lblSapNumber')}</TableCell>
                      <TableCell align="left">{t('lblStatus')}</TableCell>
                      <TableCell align="left">{t('lblDescription')}</TableCell>
                      <TableCell align="left">{t('lblTotal')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {QuerySearchScreenData ? QuerySearchScreenData.map(row => (
                      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => (
                        <TableRow
                          key={row.MaterialOrderId}
                          hover
                          classes={{ hover: classes.hover }}
                          className={classes.tableRow}
                          onClick={() => setQuery(row)}
                        >
                          <TableCell align="left">
                            {row.WorkOrderId}
                          </TableCell>
                          <TableCell align="left">
                            {`${row.SourceServiceShopCode} ${row.ServiceShop}`}
                          </TableCell>
                          <TableCell align="left">
                            {row.MaterialOrderId}
                          </TableCell>
                          <TableCell align="left">
                            {row.RecipientDsc}
                          </TableCell>
                          <TableCell align="left">
                            {row.RecipientAddress}
                          </TableCell>
                          <TableCell align="left">
                            {det.MaterialCode}
                          </TableCell>
                          <TableCell align="left">
                            {det.Material}
                          </TableCell>
                          <TableCell align="left">
                            {det.Qty}
                          </TableCell>
                          <TableCell align="left">{row.OrderDate === undefined ? '' : moment(row.OrderDate).format('DD/MM/YYYY HH:mm')}</TableCell>

                          <TableCell align="left">{det.ModelCode}</TableCell>
                          <TableCell align="left">{det.ProductName}</TableCell>
                          <TableCell align="left">
                            {row.SapNr}
                          </TableCell>
                          <TableCell align="left">
                            {det.MaterialOrderDetailStatus}
                          </TableCell>
                          <TableCell align="left">{row.Dsc}</TableCell>

                          <TableCell align="left">
                            {moneyFormat(
                              det.PriceWithWat,
                              SessionUser.TenantCode,
                              SessionUser.CurrencyUnit
                            )}
                            {`${SessionUser.CurrencyUnit}`}
                          </TableCell>
                        </TableRow>
                      )) : null
                    ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Container>

        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => setQueryPopUp(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ImagePopup}
        fullWidth
        maxWidth="sm"
        onClose={() => setImagePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
      </Dialog>

      <Dialog
        open={stokOpen}
        onClose={() => setStokOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblMaterialStockSituation')}
          <Divider />
        </DialogTitle>
        <DialogContent>
          <List component="div" dense>
            {loading ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            ) : (
              stokData.map(s => {
                return (
                  <React.Fragment>
                    <ListItem
                      fullWidth
                      alignItems="flex-start"
                      key={materialAvailabilityCode}
                    >
                      <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography
                            key={materialAvailabilityCode}
                            variant="body1"
                            className={classes.nestedRight}
                          >
                            <b>{materialAvailabilityCode}</b>
                          </Typography>
                        }
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('StorageDesc')} : {s.StorageDesc}
                              <br />
                              {t('StorageLocDesc')} : {s.StorageLocDesc}
                              <br />
                              {t('lblAdet')} : {s.Quantity}
                              <br />
                              {t('Tarih')} : {s.Date}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                );
              })
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStokOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ErpStatusOpen}
        onClose={() => setErpStatusOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblErpStatus')}
          <Divider />
        </DialogTitle>
        <DialogContent>
          <List component="div" dense>
            {loading ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            ) : (
              ErpStatusData?.orders?.map(s => {
                return (
                  <React.Fragment>
                    <ListItem
                      fullWidth
                      alignItems="flex-start"
                      key={s.orderHeader.ORDER_NO}
                    >
                      <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                      <ListItemText
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('lblSapNr')} : {s.orderHeader.ORDER_NO}
                              <br />
                              {t('lblWorkOrder')} : {s.orderHeader.PO_NUMBER}
                              <br />
                              {t('lblStatus')} : {s.orderHeader.ORDERAPPROVED}
                              <br />
                              {t('lblPrice')} : {s.orderHeader.TOTAL_VALUE + ' ' + s.orderHeader.CURRENCY}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                );
              })
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErpStatusOpen(false)} color="primary">
            {t('lblOk')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
};
export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
})(MaterialOrder);
